import React from 'react';
import { Helmet } from 'react-helmet';
import AboutUsInHome from './components/AboutUsInHome';
import Footer from './components/Footer';

import Header from './components/Header';
import Home1 from './components/Home1';
import Home2 from './components/Home2';

function Home() {
  const state = {
    activeTab: {
      home: 'active',
      aboutUs: '',
      staff: '',
      apply: '',
    },
    linkWebsite: '/',
  };
  return (
    <>
      <Helmet>
        <title>Início - Alliance Virtual</title>
      </Helmet>
      <Header activeTab={state.activeTab} linkWebsite={state.linkWebsite} />
      <main>
        <Home1 />
        <AboutUsInHome />
        <Home2 />
      </main>
      <Footer />
    </>
  );
}

export default Home;
